import React, { useState, useEffect, useRef, useContext } from 'react';
import AssignedForm from './AssignedForm'
import {FormProvider} from '@thinkwell/react.common'
import {EditModal} from '@thinkwell/react.polaris'
import {HostContext} from './contexts/Host'
import {ShopContext} from './contexts/Shop'
import pick from 'lodash/pick'

export default function EditAssigned(props) {
  const host = useContext(HostContext)
  const shop_name = useContext(ShopContext)
  const attribute = props.attribute || 'assigned_to'
  const url = props.forAccount ? host + '/accounts/assign_user' : `/admin/enrollments/${props.id}/${attribute}?shop=${shop_name}`
  const method = props.forAccount ? 'post' : 'put'
  const assignedTo = props.assigned_to
  const enrollmentId = props.enrollment_id
  const linkText = props.linkText || (assignedTo && (enrollmentId || props.id) ? 'Assign to a different student' : props.unassignedLinkText || 'Assign')
  const clearRef= useRef(null);

  const data = props.forAccount ? pick(props, ['shop_name', 'order_id', 'line_item_id',
  'line_item_quantity', 'cid', 'cemail', 'sku', 'section_id', 'enrollment_id', 'is_office_hour']) : {}

  const onTabSelected = (tabSelected) => {
    clearRef.current()
  }

  const component = (<FormProvider data={data}><EditModal
    onSave={props.onSave}
    method={method}
    active={props.active}
    url={url}
    onActive={props.onActive}
    linkText={linkText}
    onSaving={props.onSaving}
    className={props.className}
    title="Assign to:"
    clearRef={clearRef}>
    { assignedTo ?
      <div>The course is currently assigned to {assignedTo}</div>
      : null
    }
    <AssignedForm
      withSelf={props.forAccount}
      onTabSelected={onTabSelected}
      tabSelected={props.tabSelected}
      label={props.label}
    />
  </EditModal></FormProvider>)

  return component;
}
